<template>
  <div class="filter">
    <van-dropdown-menu class="first">
      <van-dropdown-item :title="statusName || '状态'" v-model="status" :options="statusList" ref="statusItem" @change="changeStatus"/>
    </van-dropdown-menu>
    <van-dropdown-menu>
      <van-dropdown-item :title="phaseName || '阶段'" v-model="phase" :options="phaseList" ref="phaseItem" @change="changePhase"/>
    </van-dropdown-menu>
    <van-dropdown-menu class="last">
      <van-dropdown-item v-model="sortType" :options="sortTypeList" ref="sortTypeItem" @change="changeSortType"/>
    </van-dropdown-menu>
  </div>
</template>

<script>

export default {
  name: "filterNav",
  props: {
    type: {}
  },
  data(){
  	return {
      status: this.$route.query.status ? ~~this.$route.query.status : 1,
      phase: this.$route.query.phase ? ~~this.$route.query.phase :  1,
      sortType: this.$route.query.sortType ? ~~this.$route.query.sortType :  2,
      statusName: "",
      phaseName: "",
      statusList: [
        { text: '全部', value: 1 },
        { text: '推荐', value: 2},
        { text: '面试', value: 3},
        { text: '成单', value: 4}
      ],
      phaseList: [
        { text: '全部', value: 1 },
        { text: '新推荐', value: 7},
        { text: '评估已通过', value: 8},
        { text: '面试待确认', value: 11},
        { text: '面试已确认', value: 12},
        { text: '面试通过', value: 14},
        { text: 'Offer', value: 17}
      ],
      sortTypeList: [
        { text: '最新反馈', value: 3},
        { text: '最新推荐', value: 2},
      ]
  	}
  },
  methods: {
    changeStatus(value){
      let params = {...this.$route.query};
      this.$refs.statusItem.toggle(false);
      this.statusList.forEach(item=>{
        if(item.value == value){
          this.statusName = item.text == '全部' ? '' : item.text;
        }
      });
      params.status = value;
      this.phase = 1;
      this.phaseName = "";
      delete params.phase;
      this.$router.replace({name: this.$route.name, query: {...params}});
    },
    changePhase(value){
      let params = {...this.$route.query};
      this.$refs.phaseItem.toggle(false);
      this.phaseList.forEach(item=>{
        if(item.value == value){
          this.phaseName = item.text == '全部' ? '' : item.text;
        }
      });
      params.phase = value;
      this.status = 1;
      this.statusName = "";
      delete params.status;
      this.$router.replace({name: this.$route.name, query: {...params}});
    },
    changeSortType(value){
      let params = {...this.$route.query};
      this.$refs.sortTypeItem.toggle(false);
      params.sortType = value;
      this.$router.replace({name: this.$route.name, query: {...params}});
    }
  },
  created(){
    if(this.status&&this.status!=1){
      this.statusList.forEach(item=>{
        if(item.value == this.status){
          this.statusName = item.text;
        }
      });
    }
    if(this.phase&&this.phase!=1){
      this.phaseList.forEach(item=>{
        if(item.value == this.phase){
          this.phaseName = item.text;
        }
      });
    }
  }
};

</script>


<style scoped lang="scss">
  .filter{
    .operation{
      display: flex;
      div{
        font-size: 14px;
        color: #333;
        flex-grow: 1;
        height: 45px;
        line-height: 45px;
        text-align: center;
        &.confirm{
          background: #22BAA5;
          color: #fff;
        }
      }
    }
  }
</style>

<style lang="scss">
  .filter{
    .van-dropdown-menu{
      flex-grow: 1;
    }
  }
  .order-list-wrap{
    .filter{
      .van-dropdown-menu__item{
        justify-content: space-between;
      }
      .first{
        .van-dropdown-menu__item{
          margin: 0 40px 0 10px;
        }
      }
      .last{
        .van-dropdown-menu__item{
          justify-content: space-around;
        }
      }
    }
  }
</style>
